import { createSelector } from 'reselect';
import { AppState } from '../rootReducer';

const getScreenedList = (state: AppState) => state.report.screenedList;
const getEnrolledPatient = (state: AppState) => state.report.enrolledPatientList;
const getDuplicatePatient = (state: AppState) => state.report.duplicatePatientList;
const getAssessmentList = (state: AppState) => state.report.assessmentList;
const getUserPerformanceList = (state: AppState) => state.report.userPerformanceList;
const getLoading = (state: AppState) => state.report.loading;
const getTotal = (state: AppState) => state.report.total;
const getSSReportList = (state: AppState) => state.report.ssReport.list;
const getSSReportLoading = (state: AppState) => state.report.ssReport.loading;
const getSSReportTotal = (state: AppState) => state.report.ssReport.total;
const getSKReportList = (state: AppState) => state.report.skReport.list;
const getSKReportLoading = (state: AppState) => state.report.skReport.loading;
const getSKReportTotal = (state: AppState) => state.report.skReport.total;
const getSKDetailsList = (state: AppState) => state.report.skDetails.list;
const getSKDetailsLoading = (state: AppState) => state.report.skDetails.loading;
const getSKDetailsTotal = (state: AppState) => state.report.skDetails.total;
const getSKDetailsView = (state: AppState) => state.report.skDetails.view;
const getSKDetailsViewLoading = (state: AppState) => state.report.skDetails.viewLoading;

export const screenedListSelector = createSelector(getScreenedList, (screenedList) => screenedList);
export const enrolledPatientSelector = createSelector(getEnrolledPatient, (enrolledPatientList) => enrolledPatientList);
export const duplicatePatientSelector = createSelector(
  getDuplicatePatient,
  (duplicatePatientList) => duplicatePatientList
);
export const assessmentListSelector = createSelector(getAssessmentList, (assessmentList) => assessmentList);
export const userPerformanceListSelector = createSelector(
  getUserPerformanceList,
  (userPerformanceList) => userPerformanceList
);
export const loadingSelector = createSelector(getLoading, (loading) => loading);
export const totalSelector = createSelector(getTotal, (total) => total);
export const ssReportListSelector = createSelector(getSSReportList, (ssReportList) => ssReportList);
export const ssReportLoadingSelector = createSelector(getSSReportLoading, (ssReportLoading) => ssReportLoading);
export const ssReportTotalSelector = createSelector(getSSReportTotal, (ssReportTotal) => ssReportTotal);
export const skReportListSelector = createSelector(getSKReportList, (skReportList) => skReportList);
export const skReportLoadingSelector = createSelector(getSKReportLoading, (skReportLoading) => skReportLoading);
export const skReportTotalSelector = createSelector(getSKReportTotal, (skReportTotal) => skReportTotal);
export const skDetailsListSelector = createSelector(getSKDetailsList, (skDetailsList) => skDetailsList);
export const skDetailsLoadingSelector = createSelector(getSKDetailsLoading, (skDetailsLoading) => skDetailsLoading);
export const skDetailsTotalSelector = createSelector(getSKDetailsTotal, (skDetailsTotal) => skDetailsTotal);
export const skDetailsViewSelector = createSelector(getSKDetailsView, (skDetailsView) => skDetailsView);
export const skDetailsViewLoadingSelector = createSelector(
  getSKDetailsViewLoading,
  (skDetailsViewLoading) => skDetailsViewLoading
);
